module.exports = __webpack_public_path__ + "img/logo-inverted-only-cloud.264b666f.png";